import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { NAVIGATION_LABELS } from '../../../helpers/constants'
import NavigationLabel from '../../NavigationLabel/NavigationLabel'

const IncidentReportsLink = ({ withUpsellingRedirect }) => {
  const { t } = useTranslation(['navbar'])

  return (
    <div className="hover-menu-item">
      <NavLink
        className={({ isActive }) =>
          isActive ? 'navmgr-item__link--active' : 'hover-menu-item__link'
        }
        to={
          withUpsellingRedirect
            ? '/dashboard/upselling/incidentReports'
            : '/dashboard/building-dashboard/incident-reports'
        }
      >
        <span>
          {t('navbar:upsellingLinks.incidentReports')}
          <NavigationLabel type={NAVIGATION_LABELS.BETA} locked={withUpsellingRedirect} />
        </span>
      </NavLink>
    </div>
  )
}

IncidentReportsLink.propTypes = {
  withUpsellingRedirect: PropTypes.bool,
}

export default IncidentReportsLink
